import { useQuery } from 'react-query'
import React, { Component } from "react";
import styled from "styled-components";
import { fetchJobsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

async function fetch() {
    const { data } = await fetchJobsExplorer('byRegion')
    return data.result;
}
function ByRegion() {
    const { data, error, isError, isLoading } = useQuery('jobsByRegion', fetch)
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer  {...dataProps } />
}
export default ByRegion